import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import { PackageFilters } from 'leash/components/packageFilters/PackageFilters';
import { PageHeaderStyled } from 'leash/components/layout/LeashLayout.styles';
import { PackagesTitle } from 'leash/components/packagesHeader/PackagesTitle';
import { usePackagesContext } from 'leash/context/packages/PackagesContext';
import { PackagesRouteParams } from 'leash/pages/packages/Packages';
import { PackageSearchCategory } from 'leash/utilities/const';
import { PackageSearchCategories } from 'leash/types';
import { TableFilter } from 'types';

export const getCategoryLabel = (category: PackageSearchCategories) => {
  const {
    PuppyId,
    BreederId,
    ContactId,
    Breed,
    Airport,
    Airline,
    Transporter,
    GroundTransporter,
    BreederName,
  } = PackageSearchCategory;
  switch (category) {
    case PuppyId:
      return 'Puppy ID';
    case BreederName:
      return 'Breeder name';
    case BreederId:
      return 'Breeder ID';
    case ContactId:
      return 'Contact ID';
    case Breed:
      return 'Breed';
    case Airport:
      return 'Airport';
    case Airline:
      return 'Airline';
    case Transporter:
      return 'Transporter';
    case GroundTransporter:
      return 'Ground transporter';
  }
};

export const getFilterValue = (filters: TableFilter, key: string): string | undefined => {
  return (filters?.[key]?.[0] as string) ?? undefined;
};

export function PackagesHeader(): ReactElement {
  const {
    state: { filters, packages },
    dispatch,
  } = usePackagesContext();
  const { category, query }: PackagesRouteParams = useParams();

  const handleClearFilters = (): void => {
    dispatch({ type: 'FILTER_PACKAGES', payload: {} });
  };

  const onSearch = (value: React.Key[], dataIndex: string) => {
    dispatch({
      type: 'FILTER_PACKAGES',
      payload: { ...filters, [dataIndex]: value },
    });
  };

  return (
    <PageHeaderStyled
      title={
        <PackagesTitle
          category={category}
          query={query}
          resultsCounts={packages.length}
        />
      }
      extra={
        <PackageFilters
          onSearch={onSearch}
          onClear={handleClearFilters}
          values={{
            departureDate: getFilterValue(
              filters,
              'travelPackage.travelProposal.departureTime',
            ),
            arrivalDate: getFilterValue(
              filters,
              'travelPackage.travelProposal.arrivalTime',
            ),
            departureLocation: getFilterValue(filters, 'breeder.stateAbbr'),
            arrivalLocation: getFilterValue(filters, 'customer.stateAbbr'),
          }}
        />
      }
    />
  );
}
